module.exports = __webpack_public_path__ + "static/media/allImpact_60y_y-1.55f6a54a.csv";